module.exports = __webpack_public_path__ + "static/media/rng-7.88cf60d8.gif";